import axios from "axios";

const api = axios.create({
  baseURL: "https://apiflow.dsdigital.tchat.telnet23.com.br",
});

export default api;
